import React, { useState, useEffect } from 'react';
import { Shield } from 'lucide-react';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('hibff_cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('hibff_cookie_consent', 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('hibff_cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-2 sm:p-4 pointer-events-none" style={{ paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 0.75rem)' }} data-testid="cookie-consent">
      <div className="pointer-events-auto max-w-3xl mx-auto bg-white border border-gray-200 rounded-xl sm:rounded-2xl shadow-2xl p-3 sm:p-5 flex items-center gap-2.5 sm:gap-4">
        <Shield size={24} className="text-purple-500 flex-shrink-0 hidden sm:block" />
        <div className="flex-1 min-w-0">
          <p className="text-[11px] leading-snug sm:text-sm sm:leading-normal text-gray-700">
            <span className="hidden sm:inline">HiBFF uses essential cookies only — to keep you logged in and remember your preferences. We do not use advertising or tracking cookies. </span>
            <span className="sm:hidden">Essential cookies only — no ads, no tracking. </span>
            <a href="/privacy" className="text-purple-600 underline">Privacy &amp; Data Safety Policy</a>
          </p>
        </div>
        <div className="flex gap-1.5 sm:gap-2 flex-shrink-0">
          <button onClick={decline} className="px-3 sm:px-4 min-h-[38px] sm:min-h-[44px] text-xs sm:text-sm text-gray-600 border border-gray-200 rounded-lg hover:bg-gray-50" data-testid="cookie-decline-btn">
            Decline
          </button>
          <button onClick={accept} className="px-3 sm:px-4 min-h-[38px] sm:min-h-[44px] text-xs sm:text-sm text-white bg-purple-600 rounded-lg hover:bg-purple-700 font-medium" data-testid="cookie-accept-btn">
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
